import React from 'react';

const IndividualTab = (props) => {
    return (
        <div className={(props.className? props.className : "tabAdministradoraConfProc ") + (props.active ? "tabAdministradoraProcesosActivo":"")} data-toggle="tab" href={"#menu" + props.id} id={"IndividualTab_" + props.id} onClick={() => props.handleClick(props.id)}>
            {props.descripcion}
        </div>
    );
}

export default IndividualTab;